import { PAGE_NOT_FOUND_NAME, REDIRECT_NAME, LAYOUT } from '../constant'

export const EXCEPTION_COMPONENT = () => import('@views/Exception/Exception.vue')

export const PAGE_NOT_FOUND_ROUTE = {
  path: '/:path(.*)*',
  name: PAGE_NOT_FOUND_NAME,
  component: EXCEPTION_COMPONENT,
  meta: {
    title: 'ErrorPage',
    flex: true,
    ignoreKeepAlive: true,
  },
}

export const REDIRECT_ROUTE = {
  path: '/redirect',
  name: REDIRECT_NAME,
  component: LAYOUT,
  meta: {
    title: REDIRECT_NAME,
    hideBreadcrumb: true,
  },
  children: [
    {
      path: '',
      name: REDIRECT_NAME,
      component: () => import(/* webpackChunkName: "redirect" */ '@views/Redirect/Index.vue'),
      meta: {
        ignoreKeepAlive: true,
      },
    },
    {
      path: '/redirect/:refresh(.*)/:path(.*)',
      name: REDIRECT_NAME,
      component: () => import(/* webpackChunkName: "redirect" */ '@views/Redirect/Index.vue'),
      meta: {
        ignoreKeepAlive: true,
      },
    },
    {
      path: '/redirect/:path(.*)',
      name: REDIRECT_NAME,
      component: () => import(/* webpackChunkName: "redirect" */ '@views/Redirect/Index.vue'),
      meta: {
        ignoreKeepAlive: true,
      },
    },
  ],
}
